module.exports = __webpack_public_path__ + "img/shape-7@2x.1ef5c61f.png";